import { navigateToPage } from '@cian/valuation-utils-component';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectMyHomeId } from '../../../selectors/selectMyHomeId';
import { trackGoToOtherMyHomeClick } from '../utils/tracking';

export function useGetGoToOtherMyHomeCard() {
  const myHomeId = useSelector(selectMyHomeId);

  return React.useCallback(
    (id: number) => {
      if (id === myHomeId) {
        return;
      }

      trackGoToOtherMyHomeClick(id);
      navigateToPage(`/my-home-profit/?myHomeId=${id}`);
    },
    [myHomeId],
  );
}
